import { Directive, inject } from '@angular/core';
import { CallidusCurrencyPipe } from '@shared/pipes/currency/callidus-currency.pipe';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { CallidusBvsVersicherungssummeKunde, VersicherungspraemieCalculationResultDto } from '@backend/models';

@Directive()
export class AdditionalCoverageBaseComponent extends DataBaseComponent {
  currencyPipe = inject(CallidusCurrencyPipe);

  calculationResult: VersicherungspraemieCalculationResultDto | null = null;

  protected readonly CallidusBvsVersicherungssummeKunde = CallidusBvsVersicherungssummeKunde;
}
